import { createSystem, defaultConfig, defineConfig, mergeConfigs } from '@chakra-ui/react';
import { baseButtonRecipe } from './recipes/baseButton';
import { tableSlotRecipe } from './slotRecipes/table';
import { linkRecipe } from './recipes/linkRecipe.tsx';
import { buildBaseTheme } from '../ThemeGen/exports.ts';

const baseTheme = buildBaseTheme({
  primaryColor: '#203260',
  secondaryColor: '#ff480e',
  tertiaryColor: '#3db358',
  buttons: {
    borderRadius: 4
  },
  table: {
    stripedColor: '#ebf0ff'
  }
});

const dlmsTheme = defineConfig({
  globalCss: {
    body: {
      backgroundColor: 'gray.50'
    }
  },
  theme: {
    keyframes: {
      flash: {
        '0%': { backgroundColor: '#203260' },
        '50%': { backgroundColor: '#ff480e' },
        '100%': { backgroundColor: '#203260' }
      }
    },
    tokens: {
      animations: {
        flash: { value: 'flash 1.5s infinite ease-in-out' }
      },
      colors: {
        activeLot: { value: '#ffdf00' },
        nextLot: { value: 'orange' }
      },
      fonts: {
        body: { value: 'Roboto, Helvetica, Arial, sans-serif' }
      }
    },
    recipes: {
      button: baseButtonRecipe(),
      link: linkRecipe
    },
    slotRecipes: {
      table: tableSlotRecipe
    }
  }
});

const merged = mergeConfigs(defaultConfig, baseTheme, dlmsTheme);
export default createSystem(merged);
